import angular from 'angular';

let app = angular.module('BatisoApp', []);

app.controller('FormController', ['$scope', '$timeout', 'filterFilter', '$http', '$httpParamSerializerJQLike',
    function($scope, $timeout, filterFilter, $http, $httpParamSerializerJQLike) {
        // console.info('FormController Loaded');
        let vm = this;
        let selection = {};

        $scope.obj = { data : [vm.step, {}] };

        $scope.surfaces = [
            { name: 'Combles perdus', value: 'lost' },
            { name: 'Combles aménagés', value: 'furnished' },
            // { name: 'Cave ou sous-sol', value: 'cave' },
            // { name: 'Garage', value: 'garage' },
            // { name: 'Vide sanitaire', value: 'sanitary' },
        ];

        $scope.numbers = [
            { name: 'one', value: 1 },
            { name: 'two', value: 2 },
            { name: 'three', value: 3 },
            { name: 'four', value: 4 },
            { name: 'five', value: 5 },
            { name: 'more', value: '+' },
        ];

        $scope.selected = function() {
            return filterFilter($scope.surfaces, { selected: true });
        };

        $scope.$watch('surfaces|filter:{selected:true}', function(nv) {
            selection = nv.map(function(surface) {
                return surface.value;
            });

            $scope.someSelected = Object.keys(selection).some(function (surface) {
                return $scope.surfaces[surface];
            });

            if (vm.step === 1) {
                $scope.obj.data[vm.step].surfaces = selection;
            }
        }, true);

        vm.follow = function(form, obj, e) {

            switch (vm.step) {
                case 1:
                    form.$valid = form.email.$valid && form.status.$valid && $scope.someSelected && form.agree.$valid;
                    break;
                case 2:
                    if ($scope.obj.data[vm.step].localization !== 'other' && typeof $scope.obj.data[vm.step].dept_code != 'undefined') {
                        delete $scope.obj.data[vm.step].dept_code;
                    }
                    if ($scope.obj.data[vm.step].localization !== '+' && typeof $scope.obj.data[vm.step][more] != 'undefined') {
                        delete $scope.obj.data[vm.step][more];
                    }
                    form.$valid = form.localization.$valid && form.number.$valid && form.scheme.$valid;
                    break;
                case 3:
                    form.$valid = form.gender.$valid && form.firstname.$valid && form.lastname.$valid;
                    break;
            }

            if (form.$valid) {
                e.preventDefault();

                obj.action = 'batiso_form';
                obj.security = batiso_form.batiso_nonce;
                obj.step = vm.step;
                obj.id = $scope.lastFormId;
                let headers = { 'Content-Type': 'application/x-www-form-urlencoded' };

                $http({
                    method: 'POST',
                    url: batiso_form.ajaxurl,
                    data: $httpParamSerializerJQLike(obj),
                    headers: headers
                }).then(function success(res) {
                    if (res.data.success) {
                        form.$setPristine();
                        form.$setValidity();
                        $scope.lastFormId = res.data.lastFormId;
                        vm.step = vm.step + 1;
                    } else {
                        console.log(res.error);
                    }
                }, function error(res) {
                    console.log(res);
                });
            }

        };

        $http.get(batiso_form.uploadsurl + '/csv/bareme.csv')
            .then(function success(res) {
                    let lines = res.data.split(/\r\n|\n/);
                    let headers = lines[0].split(',');
                    let extract = {};

                    for (let i = 1; i < lines.length; i++) {
                        let data = lines[i].split(',');
                        if (data.length === headers.length) {
                            let arr = {};
                            for (let j = 1; j < headers.length; j++) {
                                if ((j % 2) === 0) {
                                    arr['paris'] = parseInt(data[j]);
                                }
                                if ((j % 2) === 1) {
                                    arr['other'] = parseInt(data[j]);
                                }
                            }
                            if (i > 5) {
                                i = '+';
                            }
                            extract[i] = arr;
                        }
                    }

                    $scope.csv = extract;
                }, function error(res) {
                    console.log(res);
                });

        $scope.$watch('vm.batisoForm', function(form) {
            //console.log(form)
        });

    }]
);


// WEBPACK FOOTER //
// ./js/form.js